import { render, staticRenderFns } from "./archival-table.vue?vue&type=template&id=ca9caa0c"
import script from "./archival-table.vue?vue&type=script&lang=js"
export * from "./archival-table.vue?vue&type=script&lang=js"
import style0 from "./archival-table.vue?vue&type=style&index=0&id=ca9caa0c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports